import { render } from "./PrintButtonComponent.vue?vue&type=template&id=2a69b76c"
import script from "./PrintButtonComponent.vue?vue&type=script&lang=js"
export * from "./PrintButtonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/PrintButtonComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a69b76c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a69b76c', __exports__)) {
    api.reload('2a69b76c', __exports__)
  }
  
  module.hot.accept("./PrintButtonComponent.vue?vue&type=template&id=2a69b76c", () => {
    api.rerender('2a69b76c', render)
  })

}


export default __exports__